module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"questionShort":"Q{number}","questionLong":"Question {number}{new}","new":"new"},"de":{"questionShort":"F{number}","questionLong":"Frage {number}{new}","new":"neu"},"fr":{"questionShort":"Q{number}","questionLong":"Question {number}{new}","new":"nouveau"},"it":{"questionShort":"D{number}","questionLong":"Domanda {number}{new}","new":"nuova"}}')
  delete Component.options._Ctor
}
